import React from 'react';
import './refundpolicy.css'; 

function Refund1() {
  return (
    <div className="wholecontent">
      <div className="header-container">
        <h1 className="privacy">Refund Policy</h1>
      </div>
      <div className="privacycontent">
        <h6>
        At Brand Marketing Hub, located in California, we prioritize safeguarding your privacy in our web environment. We are dedicated to building and maintaining strong relationships with our clients, recognizing that their trust is crucial to our success.
        </h6>
        <h6>
          Information Collection and Use

          When you visit our website, we collect technical information to enhance and personalize your experience. This information helps us understand and improve how we engage with you.
        </h6>
        <h6>
          Frequency of Visits

          We are interested in how often you visit our site to ensure that we provide valuable and relevant content.
        </h6>
        <h6>
          Data Sharing and Security

          Your information is protected with the highest level of security. While we may share data with our business partners for advertising and analytical purposes, such as tracking unique visitors to improve our services, we ensure that all shared data is handled with strict confidentiality.
        </h6>
        <h6>
          We have robust security systems in place to guard your data from unauthorized access and misuse. Despite our best efforts to prevent it, there is always a risk of potential breaches by hackers.
        </h6>
        <h6>
          Policy Changes

          We reserve the right to modify our privacy policy as needed, with prior notice. Any updates will be posted on our website. By continuing to use our site, you agree to these terms and conditions. Please review our Terms and Privacy Policy regularly to ensure they align with your preferences.
        </h6>
        <h6>
          Thank you for choosing Brand Marketing Hub.
        </h6>
      </div>
    </div>
  );
}

export default Refund1;
